// Gate metadata is authored by ComponentControls, never by content forms.
export function buildDraftGate({
    type = 'public', tokenIds = [], collectionIds = [], compressedCollectionIds = [],
    listId = '', details = {},
}, ownerPayToUid, targetId) {
    const gate = { type, tokenIds, collectionIds, compressedCollectionIds, listId: type === 'public' ? '' : listId };
    if (type === 'donation') {
        return { ...gate, donationCompId: String(details.donationCompId || ''),
            donationThreshold: Number(details.donationThreshold || 0), campaignName: String(details.campaignName || ''),
            currency: details.currency || 'SOL', tokenMint: details.tokenMint || '' };
    }
    if (type === 'tokensHeld') {
        return { ...gate, listId: '', tokenThreshold: Number(details.tokenThreshold || 0),
            currency: details.currency || 'SOL', tokenMint: details.tokenMint || '' };
    }
    if (type === 'directPayment') {
        return { ...gate, listId: '', priceSol: Number(details.priceSol || 0),
            payToUid: String(ownerPayToUid || ''), currency: details.currency || 'SOL',
            tokenMint: details.tokenMint || '', targetId: String(targetId) };
    }
    if (type === 'scheduledAccess') {
        return { ...gate, listId: '', scheduleName: String(details.scheduleName || ''),
            startAt: String(details.startAt || ''), endAt: String(details.endAt || '') };
    }
    if (type === 'password') {
        return { ...gate, listId: '', password: String(details.password || ''),
            passwordPrompt: String(details.passwordPrompt || ''), targetId: String(targetId) };
    }
    return gate;
}
export function getComponentGateMetadata(source = {}, componentId = source.id) {
    const normalizeTarget = (gate) => gate?.type === 'password'
        ? { ...gate, targetId: String(componentId) }
        : gate;
    return {
        gate: normalizeTarget(source.gate || { type: 'public', listId: '' }),
        extraGates: (source.extraGates || []).map(normalizeTarget),
        gateLogic: source.gateLogic || 'any',
    };
}
export function composeComponentContent(draft, existingComponent, draftControls) {
    const source = existingComponent || draftControls;
    const id = existingComponent?.id ?? draft.id ?? Date.now();
    const gateMetadata = getComponentGateMetadata(source, id);
    if (!existingComponent && gateMetadata.gate.type === 'directPayment') {
        gateMetadata.gate = { ...gateMetadata.gate, targetId: String(id) };
    }
    return {
        ...(existingComponent || {}), ...draft, ...gateMetadata,
        style: source.style || {},
        coverUrl: source.coverUrl || '',
        timestampDisplay: source.timestampDisplay || 'none',
        displayMode: source.displayMode ?? draft.displayMode ?? 'full',
        id, createdAt: existingComponent?.createdAt ?? draft.createdAt ?? Date.now(),
        updatedAt: Date.now(),
    };
}
// Resolve against the current list after asynchronous content work.
export function placeInlineComponent(components, component, editingCompId, index) {
    if (!component) return null;
    const next = [...components];
    if (editingCompId != null) {
        const currentIndex = next.findIndex((item) => String(item.id) === String(editingCompId));
        if (currentIndex < 0) return null;
        next[currentIndex] = component;
    } else {
        next.splice(index, 0, component);
    }
    return next;
}
